import { css } from 'styled-components'

// This is not necessary  is just a quick
// fix and should be deleted, is done
// temporary so not to mess around with pubsweet
export default css`
  display: flex;
`
